var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.52174 0C0.684783 0 0 0.703125 0 1.5625V8.4375C0 9.29688 0.684783 10 1.52174 10H12.4783C13.3152 10 14 9.29688 14 8.4375V1.5625C14 0.703125 13.3152 0 12.4783 0H1.52174ZM1.52174 0.625H12.4783C12.9859 0.625 13.3913 1.04126 13.3913 1.5625V2.1875H0.608696V1.5625C0.608696 1.04126 1.0141 0.625 1.52174 0.625ZM0.608696 3.75H13.3913V8.4375C13.3913 8.95874 12.9859 9.375 12.4783 9.375H1.52174C1.0141 9.375 0.608696 8.95874 0.608696 8.4375V3.75ZM2.13043 4.6875V5.3125H7V4.6875H2.13043Z",
    fill: "#009B94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.93c9943b4be29b3c705db455ea634016.svg";
export { ForwardRef as ReactComponent };